var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-video"},[_c('video',{attrs:{"src":_vm.unitData.video_url,"poster":_vm.unitData.image_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }